/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest =
  {
    /**
     * Optional external end-user identifier forwarded by the API gateway.
     */
    xOnBehalfOf?: string | undefined;
  };

/** @internal */
export const RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$inboundSchema:
  z.ZodType<
    RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
    });
  });
/** @internal */
export type RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$Outbound =
  {
    "X-On-Behalf-Of"?: string | undefined;
  };

/** @internal */
export const RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$outboundSchema:
  z.ZodType<
    RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$Outbound,
    z.ZodTypeDef,
    RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
    });
  });

export function refreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequestToJSON(
  refreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest:
    RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest,
): string {
  return JSON.stringify(
    RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$outboundSchema
      .parse(
        refreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest,
      ),
  );
}
export function refreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'RefreshRepositoriesApiV1SandboxGithubRepositoriesRefreshPostRequest' from JSON`,
  );
}
